import { render } from "./eatKitPlaceSet.vue?vue&type=template&id=01ec0aa0"
import script from "./eatKitPlaceSet.vue?vue&type=script&lang=js"
export * from "./eatKitPlaceSet.vue?vue&type=script&lang=js"

import "./eatKitPlaceSet.vue?vue&type=style&index=0&id=01ec0aa0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__